import { render, staticRenderFns } from "./RateCard.vue?vue&type=template&id=62d949b3&scoped=true&lang=html&"
import script from "./RateCard.vue?vue&type=script&lang=js&"
export * from "./RateCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d949b3",
  null
  
)

export default component.exports